import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from './Components/Home/Home';
import AddArticle from './Components/Article/AddArticle';
import Login from './Components/Login/Login';
import AdminDashboard from './Components/Dashboards/AdminDashboard';
import ManageUsers from './Components/Manage/ManageUsers';
import { authGuard } from './Helpers/UserHelpers';
import AuthorDashboard from './Components/Dashboards/AuthorDashboard';
import EditArticle from './Components/Article/EditArticle';
import * as firebase from 'firebase/app'
import 'firebase/auth'
import ArticlesList from './Components/Dashboards/ArticlesList';
import About from './Components/About/About';
import Footer from './Components/Footer/Footer';
import StaffContainer from './Components/Staff/StaffContainer';
import ArticleView from './Components/Article/ArticleView';
import ClientArticlesList from './Components/Home/ClientArticlesList';
import Loading from './Components/Loading/Loading';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#104B92'
    }
  }
})

class App extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      ready: false
    }
    
    firebase.auth().onAuthStateChanged((user) => {
      this.setState({ready: true})
    })
  }
  render() {
    if (this.state.ready) {
      return (
        <div className="App">
          <BrowserRouter>
            <MuiThemeProvider theme={theme}>
              <Navbar />
              <Switch>
                <Route exact path="/articles/add" component={authGuard(AddArticle)} />
                <Route exact path="/login" component={Login} />
                <Route exact path="/admin" component={authGuard(AdminDashboard)} />
                <Route exact path="/author" component={authGuard(AuthorDashboard)} />
                <Route exact path="/manage/users" component={authGuard(ManageUsers)} />
                <Route exact path="/manage/articles" component={authGuard(ArticlesList)} />
                <Route exact path="/articles/edit/:articleId" component={authGuard(EditArticle)} />
                <Route exact path="/about" component={About} />
                <Route exact path="/staff" component={StaffContainer} />
                <Route exact path="/article/:articleId" component={ArticleView} />
                <Route exact path="/articles" component={ClientArticlesList} />
                <Route path="/" component={Home} />
              </Switch>
              <Footer />
            </MuiThemeProvider>
          </BrowserRouter>
        </div>
      );
    }
    return ( <Loading /> )
  }
}

export default App;
